import type { ReactNode } from "react";
import { AnimatePresence, motion } from "motion/react";
import { useAuthMotion } from "../authMotion";

type Props = {
  title: ReactNode;
  subtitle?: ReactNode;
  /**
   * Crossfade the subtitle whenever this changes (e.g. the sign-in step).
   * Without it the subtitle renders statically.
   */
  subtitleKey?: string;
};

/** The card's display title and the line of copy beneath it. */
export function AuthHeader({ title, subtitle, subtitleKey }: Props) {
  const { fade } = useAuthMotion();
  const subtitleClass = "text-md leading-6 text-ink-faint";

  return (
    <div className="flex flex-col gap-3">
      <h1 className="text-[2rem] leading-11 font-medium tracking-[-0.01em] text-ink-soft text-balance">
        {title}
      </h1>
      {subtitle == null ? null : subtitleKey === undefined ? (
        <p className={subtitleClass}>{subtitle}</p>
      ) : (
        // Old and new copy share one grid cell so they crossfade without a layout jump.
        <div className="grid *:col-start-1 *:row-start-1">
          <AnimatePresence initial={false}>
            <motion.p key={subtitleKey} {...fade} className={subtitleClass}>
              {subtitle}
            </motion.p>
          </AnimatePresence>
        </div>
      )}
    </div>
  );
}
